// start:ng42.barrel
export * from './multiple-user-avatar';
// end:ng42.barrel




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/multiple-user-avatar/index.ts